import * as React from "react";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { UitkPrimaryButton, UitkButtonSize } from "uitk-react-button";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);

export const SubmitButton = React.memo(
  ({
    moduleName,
    submitButtonText
  }: {
    moduleName: string;
    context: ExtendedContextStore;
    submitButtonText: string;
  }) => (
    <ButtonTracked
      tag="button"
      type="submit"
      rfrr={"hotel.search"}
      linkName="Search button click event in the wizard"
      moduleName={moduleName}
      className="wizard-submit-btn"
      text={submitButtonText}
      size={UitkButtonSize.LARGE}
      isFullWidth={true}
      data-testid="wizard-submit-button"
    />
  )
);
